var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "outer"
  }, [!_vm.isClientExists && !_vm.getLoading ? _c('div', {
    staticClass: "error"
  }, [_vm._v(" " + _vm._s(_vm.getErrorMessage) + " ")]) : _vm._e(), _vm.isClientExists && !_vm.getLoading ? _c('div', {
    staticClass: "main"
  }, [_c('h1', [_vm._v("Authorize \"" + _vm._s(_vm.partnerName) + "\" to \"MYWHOOSH\"")]), _c('h3', [_vm._v("\"" + _vm._s(_vm.partnerWebsite) + "\"")]), _c('div', {
    staticClass: "action"
  }, [_c('button', {
    staticClass: "btn btn-authorize",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.authorize
    }
  }, [_vm._v(" Authorize ")]), _c('button', {
    staticClass: "btn btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" Cancel ")])]), _c('p', [_vm._v(" To revoke access to an application, please visit your settings at any time. ")]), _vm._m(0), _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(" In case you are facing any issue while Authorize, try again after doing clear cache of you browser. ")])]) : _vm._e()]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_vm._v(" By authorizing an application you continue to operate under our "), _c('a', {
    attrs: {
      "href": "/terms-and-conditions",
      "target": "_blank"
    }
  }, [_vm._v("Terms of Service")]), _vm._v(". ")]);
}]

export { render, staticRenderFns }